// import { LoadingOverlay } from "@axl/accel-framework/components";
import { Layout } from "antd";
// import Header from "App/layouts/BasicLayout/components/Header/Header";
// import Chat from "App/shared/Chat/Chat";
// import { useSDKUtils } from "components/hooks/useSDK";
// import AxlDataProvider from "App/shared/providers/AxlDataProvider/AxlDataProvider";
// import UIAppState from "App/UIAppState/UIAppState";
// import { useUser } from "components";
// import { observer } from "mobx-react";
// import { useInstance } from "react-ioc";
// import { Header } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
// import { SchoolStore, UIStore } from "stores";

// import UserFooter from "../../shared/UserFooter/UserFooter";

import { Chat } from "@app/features/chat/Chat";
import { useDevice } from "@app/shared/lib/DeviceProvider";
import { useSchool } from "@app/shared/lib/hooks";
import { useUser } from "@app/shared/lib/hooks/useUser";

import { CookieNotification } from "../CookieNotification";
import { LoadingOverlay } from "../LoadingOverlay";
import { UIAppState } from "../UIAppState/UIAppState";

import { Header } from "./components/Header/Header";

import styles from "./BasicLayout.module.scss";

export const BasicLayout: React.FC = () => {
  const { deviceSize } = useDevice();
  const user = useUser();
  const school = useSchool();
  // const schoolStore = useInstance(SchoolStore);
  //   const { resetCourse } = useSDKUtils();

  //   useEffect(() => {
  //     resetCourse();
  //   }, []);

  if (user.user == null) return <LoadingOverlay position="absolute" />;

  return (
    <div data-size={deviceSize}>
      <Layout className={styles.content_layout}>
        <Header />
        <Layout.Content className="overflow-auto">
          {/* <AxlDataProvider> */}
          <Outlet />
          {/* </AxlDataProvider> */}
          {/* {schoolStore.hasUserFooter && (
            <UserFooter html={schoolStore.school.settings.footerHtml} />
          )} */}
          <CookieNotification />
        </Layout.Content>
      </Layout>
      {school.supportChatEnabled && <Chat />}
      <UIAppState />
    </div>
  );
};
